import React, { useState } from "react";
import styled from "styled-components";
import { useTranslate } from '@tolgee/react';
import copy from "copy-to-clipboard";

import { ReactComponent as CloseIcon } from "../../Assets/iconsv2/generic/closeBtn.svg";
import { useNotify } from "../../Helpers/Notifications";
import PrimaryButton from "./PrimaryButton";

const InAppBrowserBanner = () => {
  const { t } = useTranslate();
  const { notifySuccess } = useNotify();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const handleCopyLink = () => {
    copy(window.location.href);
    notifySuccess(t('misc.link_copied'));
  };

  return (
    <Container>
      <CloseBtn onClick={() => setDismissed(true)}>
        <CloseIcon />
      </CloseBtn>
      <Text>{t('conferences.in_app_browser_banner_title')}</Text>
      <Text>{t('conferences.in_app_browser_banner_body')}</Text>
      <PrimaryButton text={t('misc.copy_link')} onClick={handleCopyLink} />
    </Container>
  );
};

export default InAppBrowserBanner;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: ${({ theme }) => theme.first_time_message.background};
  padding: 16px;
  margin: 8px 16px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  position: relative;
`;

const Text = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
`;

const CloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  max-width: 24px;
  position: absolute;
  top: -10px;
  right: -10px;

  svg {
    color: ${({ theme }) => theme.menu.selectedOpionBackground};
    stroke: ${({ theme }) => theme.sidebar.borderColor};
  }
`;
